import { produce } from 'immer';
import { AnyAction } from 'redux';
import dayjs from 'dayjs';
import { CleaningWidgetsFleetDashboardActions } from './cleaningWidgetsFleetDashboardActions';
import { Optional } from 'lib/types/Optional';
import { MachineWithCleaningReport } from 'app/modules/machine-inventory/interfaces/Machine.types';

export interface CleaningWidgetsFleetDashboardState {
  data: Optional<MachineWithCleaningReport[]>;
  isLoading: boolean;
  userHasInteracted: boolean;
  filters: {
    period: {
      startDate: string;
      endDate: string;
    };
  };
}

export const initialState: CleaningWidgetsFleetDashboardState = {
  data: null,
  isLoading: false,
  userHasInteracted: false,
  filters: {
    period: {
      startDate: dayjs().startOf('week').startOf('day').toISOString(),
      endDate: dayjs().endOf('day').toISOString(),
    },
  },
};

export const cleaningWidgetsFleetDashboardReducer = (
  state = initialState,
  action: AnyAction
): CleaningWidgetsFleetDashboardState =>
  produce(state, draft => {
    switch (action.type) {
      case CleaningWidgetsFleetDashboardActions.GET_CLEANING_LIST_WITH_OPERATING_TIME_REQUEST: {
        draft.isLoading = true;
        return draft;
      }

      case CleaningWidgetsFleetDashboardActions.GET_CLEANING_LIST_WITH_OPERATING_TIME_SUCCESS: {
        const { machines } = action.payload;
        draft.isLoading = false;
        draft.userHasInteracted = false;
        draft.data = machines?.data ?? [];
        return draft;
      }

      case CleaningWidgetsFleetDashboardActions.GET_CLEANING_LIST_WITH_OPERATING_TIME_ERROR: {
        draft.isLoading = false;
        draft.userHasInteracted = false;
        return draft;
      }

      case CleaningWidgetsFleetDashboardActions.RESET_STATE: {
        draft.isLoading = false;
        draft.userHasInteracted = false;
        return draft;
      }

      case CleaningWidgetsFleetDashboardActions.SET_PERIOD_FILTER: {
        const { period } = action.payload;

        draft.filters.period = period;
        draft.userHasInteracted = true;
        return draft;
      }

      default:
        return draft;
    }
  });
